import React, { Component } from "react";

import DeleteIcon from "calcite-ui-icons-react/TrashIcon";
import EditIcon from "calcite-ui-icons-react/PencilIcon";
import SaveIcon from "calcite-ui-icons-react/SaveIcon";
import CancelIcon from "calcite-ui-icons-react/XCircleIcon";

import Button from "../../../common/components/Button";
import Context from "../../../context/Context";
import FieldNames from "../../../aiim/datasets/FieldNames";
import { ModalController } from "../../../common/components/Modal";
import OfficePlan from "../../base/OfficePlan";
import Rdx from "../../../redux/Rdx";
import TextField from "../../../common/components/TextField";
import Topic from "../../../context/Topic";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as component from "../../../components/util/component";

import { HeaderContainer, Title, ButtonContainer } from '../../styles/Work/areaHeader';

class AreaHeader extends Component {

  useRdx = true;

  constructor(props) {
    super(props);
    const areaItem = this.getAreaItem();
    const areaName = aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_NAME);
    this.state = component.newState({
      areaName: areaName,
      expanded: false,
      editOn: false,
      tempTitle: ''
    });
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  deleteClicked = () => {
    const i18n = Context.instance.i18n;
    //const rdxActiveAreaKey = this.props.rdxActiveAreaKey;
    const options = {
      title: i18n.spaceplanner.areaProperties.delCaption,
      message: i18n.spaceplanner.areaProperties.delPrompt,
      okLabel: i18n.spaceplanner.areaProperties.del,
      closeOnOK: false,
      closeOnCancel: false,
    }
    ModalController.confirm(options).then(result => {
      if (result.ok) {
        const plan = Context.instance.spaceplanner.activePlan;
        const areasTable = plan && plan.areasTable;
        const areaItem = this.getAreaItem();
        areasTable.deleteArea(areaItem).then(() => {
          Topic.publish(Topic.PlanModified, {
            action: OfficePlan.Action_AssignmentsUpdated
          });
          const areaType = this.getAreaType();
          let rdxActiveAreaKey;
          if(areaType === "hotel") rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTEL_AREA_ID;
          else if(areaType === "hotdesk") rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTDESK_AREA_ID;
          Rdx.setValue(null, rdxActiveAreaKey, null);
          result.controller.close();
        }).catch(error => {
          result.controller.close();
          console.error("Error updating area", error);
          Topic.publishErrorUpdatingData(error.submessage);
        });
      } else {
        result.controller.close();
      }
    });
  }

  editClicked = () => {
    this.setState({ editOn: true, tempTitle: this.state.areaName });
  }

  editCancelClicked = () => {
    this.setState({ editOn: false, areaName: this.state.tempTitle });
  }

  getAreaId = () => {
    const areaItem = this.getAreaItem();
    return aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_ID);
  }

  getAreaItem = () => {
    return this.props.areaItem;
  }

  getAreaType = () => {
    return this.props.areaType;
  }

  getRdxActiveAreaKey = () => {
    return "area_id"
  }

  onChangeName = evt => {
    this.setState({ areaName: evt.target.value });
  }

  onKeyDownName = evt => {
    if (evt.key === "Enter") {
      this.saveClicked();
    }
  }

  render() {
    const i18n = Context.instance.i18n;
    const areaName = this.state.areaName;
    const editOn = this.state.editOn;
    const { rdxActiveAreaId } = this.props;

    return (
      <HeaderContainer>
        <Title>
          {
            editOn ? <TextField className={"i-areaheader-textfield"}
              value={areaName}
              onChange={this.onChangeName}
              onKeyDown={this.onKeyDownName} /> : areaName
          }
        </Title>
        <ButtonContainer>
          {rdxActiveAreaId ?
            editOn ?
              (<>
              <Button key="clear" clear={true}
                title={i18n.general.cancel}
                onClick={this.editCancelClicked}
                iconButton={true} icon={<CancelIcon />} />
              <Button key="save" clear={true}
                title={i18n.spaceplanner.areaProperties.save}
                onClick={this.saveClicked}
                iconButton={true} icon={<SaveIcon />} />
                </>
              ) :
              (<><Button key="edit" clear={true}
                title={i18n.spaceplanner.areaProperties.edit}
                onClick={this.editClicked}
                iconButton={true} icon={<EditIcon />} />
                <Button key="delete" clear={true}
                  title={i18n.spaceplanner.areaProperties.del}
                  onClick={this.deleteClicked}
                  iconButton={true} icon={<DeleteIcon />} />
              </>)
            : null
          }
        </ButtonContainer>
      </HeaderContainer>
    );
  }

  saveClicked = () => {
    const areaItem = this.getAreaItem();
    const plan = Context.instance.spaceplanner.activePlan;
    const areasTable = plan && plan.areasTable;
    let areaName = this.state.areaName;
    if (typeof areaName === "string") areaName = areaName.trim();
    if (areaName.length > 0) {
      areasTable.updateArea(areaItem, areaName).then(result => {
        Topic.publish(Topic.PlanModified, {
          action: OfficePlan.Action_AssignmentsUpdated
        });
        this.setState({ editOn: false });
      }).catch(error => {
        console.error("Error updating area", error);
        Topic.publishErrorUpdatingData(error.submessage);
      });
    }
  }

}

export default AreaHeader;
